import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select } from "@/components/ui/select";
import type { CharacteristicValueInput } from "@/types/batches.types";

export interface CharacteristicFieldDef {
  id: string;
  name: string;
  kind: "LIST" | "TEXT";
  required: boolean;
  options: Array<{ id: string; label: string }>;
}

interface CharacteristicValueFieldProps {
  idPrefix: string;
  def: CharacteristicFieldDef;
  value: CharacteristicValueInput | undefined;
  onChange: (value: CharacteristicValueInput | null) => void;
  disabled?: boolean;
}

/**
 * Spec 084 — o campo de UMA característica: lista vira seleção, texto livre vira campo de texto. É o
 * mesmo campo na ordem de produção e na correção da batelada.
 */
export function CharacteristicValueField({
  idPrefix,
  def,
  value,
  onChange,
  disabled,
}: CharacteristicValueFieldProps) {
  const id = `${idPrefix}-${def.id}`;
  return (
    <div className="space-y-1.5">
      <Label htmlFor={id}>
        {def.name}{" "}
        <span className="text-[11px] font-normal text-text-tertiary">
          · {def.required ? "obrigatória" : "opcional"}
        </span>
      </Label>
      {def.kind === "LIST" ? (
        <Select
          id={id}
          value={value?.valueId ?? ""}
          disabled={disabled}
          onChange={(e) =>
            onChange(e.target.value ? { characteristicId: def.id, valueId: e.target.value } : null)
          }
        >
          <option value="">Não informado</option>
          {def.options.map((o) => (
            <option key={o.id} value={o.id}>
              {o.label}
            </option>
          ))}
        </Select>
      ) : (
        <Input
          id={id}
          value={value?.text ?? ""}
          maxLength={200}
          disabled={disabled}
          placeholder="Não informado"
          onChange={(e) =>
            onChange(
              e.target.value.trim() ? { characteristicId: def.id, text: e.target.value } : null
            )
          }
        />
      )}
    </div>
  );
}
